import React, { useState, useEffect } from "react";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  Form,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useDispatch } from "react-redux";

import avatar from "../../../assets/images/users/avatar-1.jpg";
// actions
import { useTranslation } from "react-i18next";
import { putProfiles } from "store/thunks";
import userApi from "api/userApi";
import { toast } from "react-toastify";
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";

const OperatorUserProfile = () => {
  const dispatch = useDispatch<any>();
  const { t, i18n } = useTranslation();

  const [user, setUser] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubmit = async (values: any) => {
    if(!user?.id) return;

    try {
      setIsLoading((_prev) => true);
      const data = {
        password: values?.password,
      };

      const response: any = await putProfiles(data);
      if (response?.data) {
        setIsLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
        validation.setFieldValue('password', '');
        validation.setFieldValue('confirm_password', '');
        // triggerRefresh && triggerRefresh();
      } else {
        setIsLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      password: "",
      confirm_password: ""
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(6, `${t("Password must be at least 6 characters")}`)
        .required(`${t("New Password is required")}`),
      confirm_password: Yup.string().oneOf(
        [Yup.ref("password")],
        `${t("Passwords must match")}`
      ),
    }),
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    const handleCallUser = async () => {
      try {
        const res: any = await userApi.userProfile();
        if(res?.data) {
          setUser(res?.data)
        }
      } catch (error: any) {
        return error;
      }
    };

    handleCallUser();
  }, []);

  useEffect(() => {
    document.title = "Picaverse Agency Star+ System - Profile";
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg="12">
              {/* {error && error ? <Alert color="danger">{error}</Alert> : null}
              {success ? (
                <Alert color="success">Username Updated To {userName}</Alert>
              ) : null} */}

              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="mx-3">
                      <img
                        src={avatar}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5>{user?.name}</h5>
                        <p className="mb-1">{t('Email')} : {user?.email}</p>
                        {
                          user?.role === "agency" && (
                            <>
                              <p className="mb-0">{t('Agency Code')} : {user?.agency?.code}</p>
                              <p className="mb-0">{t('Agency Name')} : {user?.agency?.name}</p>
                            </>
                          )
                        }
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {
            user?.role === "agency" && (
              <>
              <h4 className="card-title mb-4">{t('Change Password')}</h4>
                <Card>
                  <CardBody>
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <Row className="g-2">
                        <Col lg={6}>
                          <div>
                            <Label
                              htmlFor="newpasswordInput"
                              className="form-label"
                            >
                              {t("New Password")}{" "}
                              <span className="text-danger"> *</span>
                            </Label>
                            <Input
                              name="password"
                              type="password"
                              className="form-control"
                              id="newpasswordInput"
                              placeholder={t("New Password")}
                              value={
                                validation?.values?.password
                              }
                              onChange={(event: any) =>
                                validation.setFieldValue(
                                  "password",
                                  event?.target?.value
                                )
                              }
                            />
                            {validation.touched.password &&
                            validation.errors.password ? (
                              <div className="text-danger mt-2">
                                {validation.errors.password}
                              </div>
                            ) : null}
                          </div>
                        </Col>

                        <Col lg={6}>
                          <div>
                            <Label
                              htmlFor="confirmpasswordInput"
                              className="form-label"
                            >
                              {t("Confirm Password")}{" "}
                              <span className="text-danger"> *</span>
                            </Label>
                            <Input
                              name="confirm_password"
                              type="password"
                              className="form-control"
                              id="confirmpasswordInput"
                              placeholder={t("Confirm Password")}
                              value={
                                validation?.values?.confirm_password
                              }
                              onChange={(event: any) =>
                                validation.setFieldValue(
                                  "confirm_password",
                                  event?.target?.value
                                )
                              }
                            />
                            {validation.touched.confirm_password &&
                            validation.errors.confirm_password ? (
                              <div className="text-danger mt-2">
                                {validation.errors.confirm_password}
                              </div>
                            ) : null}
                          </div>
                        </Col>
                      </Row>

                      <div className="text-left mt-4">
                        <Button type="submit" color="primary">
                          {t('Update Password')}
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </>
            )
          }
        </Container>
      </div>
    </React.Fragment>
  );
};

export default OperatorUserProfile;
